module.exports = __webpack_public_path__ + "./Zoe_color_36ead61ea53e659a49587cf7849b75ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Zoe_color.jpg
// module id = 610
// module chunks = 0